import AIGradientIcon from 'assets/svg/icons/AIGradientIcon';
import classNames from 'classnames';
import { Button } from 'components/atoms/Button';
import { useAiMetadata } from 'contexts/AIMetadataProvider';
import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { ChevronDownIconOutline } from 'utils/icons';

const AIAssistantSummary: FC<{
  message?: string;
  showAskAIAssistant?: boolean;
  wrapperClassName?: string;
}> = ({ message, showAskAIAssistant, wrapperClassName }) => {
  const { t } = useTranslation();

  const { setIsHelperOpen } = useAiMetadata();

  const [isOpen, setIsOpen] = useState(true);

  if (!message) return null;

  return (
    <Button
      asDefault
      className={classNames(
        'flex gap-2 p-2.5 rounded-lg items-start',
        wrapperClassName,
        {
          'ai-border-animated': !isOpen,
          'ai-border': isOpen,
        },
      )}
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="flex items-center justify-center">
        <AIGradientIcon className="w-6 h-6" />
      </div>

      <div
        className={classNames(
          'transition-all duration-300 overflow-hidden text-left pt-0.5',
          isOpen && 'max-h-[400px]',
          !isOpen && 'max-h-[26px]',
        )}
      >
        <div className="gap-1 text-sm">
          <ReactMarkdown
            components={{
              p: ({ children }) => (
                <p className="text-primary-700 mb-1">{children}</p>
              ),
              em: ({ children }) => (
                <p className="text-primary-700 mb-1 font-bold">{children}</p>
              ),
            }}
          >
            {message}
          </ReactMarkdown>
        </div>

        {showAskAIAssistant ? (
          <Button
            structure="text"
            onClick={() => setIsHelperOpen(true)}
            color="taxes"
            className="!font-semibold underline"
          >
            {t('repository.document_form.ask_ai_cta')}
          </Button>
        ) : null}
      </div>

      <div className="flex items-center justify-center pt-0.5">
        <ChevronDownIconOutline className="w-5 h-5" />
      </div>
    </Button>
  );
};

export default AIAssistantSummary;
